import stylesData from './data.json'

enum Density {
  ONE = '1x',
  TWO = '2x',
}

export enum Viewport {
  Fourk = 'zt.fourk',
  FullHD = 'zt.fullhd',
  Widescreen = 'zt.widescreen',
  Desktop = 'zt.desktop',
  Tablet = 'zt.tablet',
  MobileTablet = 'zt.mobile_tablet',
  Mobile = 'zt.mobile',
}

export interface ResponsiveImageStyle {
  id: string
  density: Density
  viewport: Viewport
}

export interface ResponsiveStyle {
  name: string
  styles: ResponsiveImageStyle[]
}

const styles: ResponsiveStyle[] = stylesData.data
  .responsiveImageStyles as ResponsiveStyle[]

export type ResponsiveStyleName =
  | 'column_fifth'
  | 'column_full'
  | 'column_half'
  | 'column_quarter'
  | 'column_third'
  | 'content_fullwidth'
  | 'content_fullwidth_4_3'
  | 'grid_small'
  | 'hero'
  | 'image_gallery'
  | 'page_hero'
  | 'sidebar_right'
  | 'teaser'
  | 'teaser_medium'
  | 'teaser_small'
  | 'test_fullwidth'
  | 'text_image_box'
  | 'viewport_full'
  | 'hero_slider'
  | 'employee_portrait'

export const responsiveStylesMap: Map<string, ResponsiveStyle> = styles.reduce(
  (acc, item) => {
    acc.set(item.name, item)
    return acc
  },
  new Map(),
)

export const BREAKPOINTS: Record<string, string> = {
  [Viewport.Fourk]: 'all and (min-width: 1920px)',
  [Viewport.FullHD]: 'all and (min-width: 1408px)',
  [Viewport.Widescreen]: 'all and (min-width: 1216px)',
  [Viewport.Desktop]: 'all and (min-width: 1024px)',
  [Viewport.Tablet]: 'all and (min-width: 768px)',
  [Viewport.MobileTablet]: 'all and (min-width: 420px)',
  [Viewport.Mobile]: 'all and (max-width: 768px)',
}

export const breakpointOrder: string[] = Object.keys(BREAKPOINTS)

export function getImageStyleUrl(
  style: string,
  url: string,
  hash: string,
): string {
  return `/sites/default/files/styles/${style}/public/${url}?h=${hash}`
}

export function getBaseUrl(url = ''): string | undefined {
  const matches = /sites\/default\/files\/(.*)/gm.exec(url)
  if (matches) {
    return matches[1]
  }
}
